module.exports = __webpack_public_path__ + "static/cover-fd53df36ef9c3f675ba584ad9aaea318.png";